import React from "react";

import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import PlacementQuestionsList from "../../components/PlacementQuestionsList";
import PlacementTestList from "../../components/PlacementTestList";

const AdminPlacementTest: React.FC = () => {
  return (
    <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Placement Questions"></CardHeader>
          <CardContent>
            <PlacementQuestionsList></PlacementQuestionsList>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Placement Tests"></CardHeader>
          <CardContent>
            <PlacementTestList></PlacementTestList>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AdminPlacementTest;
